export const tr = {
    format: 'Format',
    operatorName: 'Operatör',
    selected: 'Seçilenler'
};
